import Store from "@/store/index.js";
import axios from "axios";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
const domain = Store.state.domain;
export default {
    Desencriptar(vm, url) {
        var datos = new FormData();
        datos.append("url", url);
    },
    //Desconclusion
    async ValidarEFirma(vm, efirma) {
        var formData = new FormData();
        formData.append("efirma", efirma);

        let response = await vm.axios.post(
            `${domain.domainNameForApi}Desconclusion/ValidarEFirma`,
            formData
        );

        return response.data;
    },

    async ObsSolicitudDesc(vm, datosReporte) {
       
        var formData = new FormData();
        formData.append("nrreporte", datosReporte.nrreporte);
        formData.append("svindice", datosReporte.svindice);

        let response = await vm.axios.post(
            `${domain.domainNameForApi}Desconclusion/ObservacionesDesconclusion`,
            formData
        );

        return response.data;
    },

    async fechasReporte(vm, datosReporte) {
        
        var formData = new FormData();
        formData.append("nrreporte", datosReporte.nrreporte);
        formData.append("svindice", datosReporte.svindice);

        let response = await vm.axios.post(
            `${domain.domainNameForApi}Desconclusion/FechasReporteDesconclusion`,
            formData
        );

        return response.data;
    },

    async AutorizarDesconclusion(vm, autorizaRadio, eliminarRadio, firmaElectronica, observacionesDesconclusion, fechaCerrado, fechaConclusion,datosReporte,svfhcon) {

        
        var formData = new FormData();
        formData.append("nrreporte", datosReporte.nrreporte);
        formData.append("svindice", datosReporte.svindice);
        formData.append("autorizaRadio", autorizaRadio);
        formData.append("eliminarRadio", eliminarRadio);
        formData.append("firmaElectronica", firmaElectronica);
        formData.append("observacionesDesconclusion", observacionesDesconclusion);
        formData.append("fechaCerrado", fechaCerrado);
        formData.append("fechaConclusion", fechaConclusion);
        formData.append("aiclave", datosReporte.aiclave);
        formData.append("svfhcon", svfhcon);


        let response = await vm.axios.post(
            `${domain.domainNameForApi}Desconclusion/AutorizarDesconclusion`,
            formData
        );

        return response.data;
    },
    //FIN Desconclusion


    //Solicitud Desconclusion
    async ValidarPassword(vm, password) {

        var formData = new FormData();
        formData.append("password", password);

        let response = await vm.axios.post(
            `${domain.domainNameForApi}Desconclusion/VerificarPasswordLogin`,
            formData
        );

        return response.data;
    },

    async GuardarSolicitudDesconclusion(vm, password,obs,datos) {

        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        formData.append("password", password);
        formData.append("observaciones", obs);

        let response = await vm.axios.post(
            `${domain.domainNameForApi}Desconclusion/GuardarSolicitudDesconclusion`,
            formData
        );

        return response.data;
    },


    async VerificarDesconclusion(vm,datos) {
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        return axios.post(`${domain.domainNameForApi}Desconclusion/VerificarDesconclusion`, formData).then((response) => response.data);
    },

    async DatosDesconclusion(vm,datos) {
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        formData.append("aiclave", datos.aiclave);
        let response = await vm.axios.post(
            `${domain.domainNameForApi}Desconclusion/DatosDesconclusion`,
            formData
        );
        return response.data[0];
    },
};
